import React from "react";

export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden border-b border-border">
      <div className="absolute -top-32 right-0 h-96 w-96 rounded-full bg-primary/10 blur-[120px]" />
      <div className="container-x relative py-16 md:py-20">
        {eyebrow && <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-primary mb-3">{eyebrow}</span>}
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-muted-foreground max-w-2xl leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
